import { useEffect, useState } from 'react'
import { Table } from 'antd'
import { detailModel } from './detailModel'
import { OrderDetailResult } from '../../settleTypes'
import { useGlobalModel } from "@/model/globalModel";
import { useNavModel } from "@/model/navModel";
import YhTootip from '@/components/YhTootip'

export function DataTable() {

    const {
        dataSource, pgCfg, loadData, loading,
        selectedRowKeys, setSelectedRowKeys,
        selectedData, setSelectedData,
        formValues,
    } = detailModel()

    const { ciGetTreeNodeValue } = useGlobalModel(() => []);
    const { addNav } = useNavModel(() => []);
    const [columns, setColumns] = useState<any[]>([])

    useEffect(() => {
        setSelectedRowKeys([]);
        setSelectedData([]);
        setColumns([...startColumns, ...endColumns]);
        loadData();
    }, [])

    useEffect(() => {
        if (dataSource != null && dataSource.length > 0) {
            const customerColumns = dataSource?.[0].fields.map(e => {
                return {
                    title: e.fieldName,
                    width: e.fieldName.length * 15,
                    align: 'center',
                    dataIndex: e.fieldCode,
                    render: (text) => <YhTootip text={text} />,
                };
            })
            getColumns(customerColumns);
        }
    }, [dataSource])

    const getColumns = (customerColumns: any[]) => {
        setColumns([...startColumns, ...customerColumns, ...endColumns])
    }

    const startColumns: any[] = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            dataIndex: '',
            render: (t, r, i) => i + 1,
        },
        {
            title: '工单编号',
            width: 180,
            align: 'center',
            dataIndex: 'orderCode',
            render: (text, r) => (
                <div style={{ color: 'rgb(62, 103, 244)', cursor: 'pointer' }}
                    onClick={() => { addNav("4-3", { id: r.id, mode: "", orderInfo: r }) }}>
                    {text}
                </div>
            ),
        },
        {
            title: '工单状态',
            width: 100,
            align: 'center',
            dataIndex: 'orderStatus',
            render: (text) => ciGetTreeNodeValue(text),
        },
        {
            title: '客户名称',
            width: 200,
            align: 'center',
            dataIndex: 'customerName',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '服务方式',
            width: 100,
            align: 'center',
            dataIndex: 'serviceMethod',
            render: (text) => ciGetTreeNodeValue(text),
        },
        {
            title: '故障类型',
            width: 100,
            align: 'center',
            dataIndex: 'faultClassification',
            render: (text) => <YhTootip text={ciGetTreeNodeValue(text) ?? ""} style={{ width: 100 }} />,
        },
        {
            title: '车辆牌照',
            width: 100,
            align: 'center',
            dataIndex: 'customerVehicleCode',
            render: (text) => <YhTootip text={text} style={{ width: 100 }} />,
        },
        {
            title: '工单类型',
            width: 100,
            align: 'center',
            dataIndex: 'orderType',
            render: (text) => <YhTootip text={ciGetTreeNodeValue(text) ?? ""} style={{ width: 100 }} />,
        },
        {
            title: '工时费',
            width: 100,
            align: 'center',
            dataIndex: 'itemActualAmount',
            render: (text) => <YhTootip text={text} style={{ width: 100 }} />,
        },
        {
            title: '配件费',
            width: 100,
            align: 'center',
            dataIndex: 'orderMaintainMaterialAmount',
            render: (text) => <YhTootip text={text} style={{ width: 100 }} />,
        },
        {
            title: '工单金额',
            width: 100,
            align: 'center',
            dataIndex: 'orderActualAmount',
            render: (text) => <YhTootip text={text} style={{ width: 100 }} />,
        }
    ]

    const endColumns: any[] = [
        {
            title: '成本金额',
            width: 100,
            align: 'center',
            dataIndex: 'materialCostSumAmount',
            render: (text) => <YhTootip text={text} style={{ width: 100 }} />,
        },
        {
            title: '工单来源',
            width: 100,
            align: 'center',
            dataIndex: 'orderSource',
            render: (text) => <YhTootip text={ciGetTreeNodeValue(text) ?? ""} style={{ width: 100 }} />,
        },
        {
            title: '备注',
            width: 150,
            align: 'center',
            dataIndex: 'remark',
            render: (text) => <YhTootip text={text} style={{ width: 150 }} />,
        },
        {
            title: '完成时间',
            width: 140,
            align: 'center',
            dataIndex: 'orderCompletedTime',
            render: (text) => <YhTootip text={text} style={{ width: 140 }} />,
        },
        {
            title: '审核员',
            width: 100,
            align: 'center',
            dataIndex: 'reviewerName',
            render: (text) => <YhTootip text={text} style={{ width: 100 }} />,
        }
    ]

    const onRow = (record: any, selected: boolean) => {
        let arr: any = [];
        let list: any = [];
        if (selected) {
            arr = Array.from(new Set([...selectedRowKeys, record.id]));
            list = Array.from(new Set([...selectedData, record]));
        } else {
            arr = selectedRowKeys.filter(item => { return item !== record.id });
            list = selectedData.filter(item => item.id !== record.id)
        }
        setSelectedRowKeys(arr);
        setSelectedData(list);
    };

    const onSelectAll = (selected: boolean, changeRows: OrderDetailResult[]) => {
        if (selected) {
            let addSelected: string[] = [];
            let addRows: OrderDetailResult[] = [];
            for (const item of changeRows) {
                addSelected.push(item.id);
                addRows.push(item);
            }
            setSelectedRowKeys([...addSelected, ...selectedRowKeys]);
            setSelectedData([...addRows, ...selectedData]);
        } else {
            setSelectedRowKeys(selectedRowKeys.filter((id) => {
                return !changeRows.some((item) => item.id === id)
            }));
            setSelectedData(selectedData.filter((data) => {
                return !changeRows.some((item) => item.id === data.id)
            }));
        }
    }

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                rowSelection={{
                    selectedRowKeys: selectedRowKeys,
                    onSelectAll: (selected, selectedRows, changeRows) => onSelectAll(selected, changeRows),
                    onSelect: (record, selected, selectedRows) => onRow(record, selected),
                }}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                onRow={(record) => {
                    return {
                        onClick: event => onRow(record, !selectedRowKeys.includes(record.id)),
                        onContextMenu: (e) => {
                            e.preventDefault()
                            onRow(record, !selectedRowKeys.includes(record.id))
                        },
                    };
                }}
                scroll={{ x: 'max-content', y: 'calc(100vh - 470px)' }}
            />
        </>
    )
}
